export function isWMF() {
  return process.env.NEXT_PUBLIC_UNION === '8c29f3dc-a9a4-47ae-850b-988553ee8621';
}
